import React from 'react';

// Self-contained button for the courseShare feature (no dependency on other
// feature modules). Mirrors the small primitive shape used across the app.
const VARIANTS = {
  primary: {
    background: 'var(--btn-primary-bg)',
    color: 'var(--btn-primary-text)',
    border: '1px solid transparent',
  },
  secondary: {
    background: 'var(--btn-secondary-bg)',
    color: 'var(--btn-secondary-text)',
    border: '1px solid var(--btn-secondary-border)',
  },
  danger: {
    background: 'var(--danger)',
    color: 'var(--text-inverted)',
    border: '1px solid transparent',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--text-primary)',
    border: '1px solid transparent',
  },
};

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  style,
  ...rest
}) {
  const v = VARIANTS[variant] || VARIANTS.primary;
  const padY = size === 'sm' ? 7 : 11;
  const padX = size === 'sm' ? 12 : 16;
  const fontSize = size === 'sm' ? 13 : 14;
  return (
    <button
      disabled={disabled || loading}
      style={{
        padding: `${padY}px ${padX}px`,
        fontSize,
        fontWeight: 600,
        borderRadius: 10,
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        opacity: disabled || loading ? 0.6 : 1,
        transition: 'background 0.15s ease, opacity 0.15s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        ...v,
        ...style,
      }}
      {...rest}
    >
      {loading && (
        <span
          aria-hidden="true"
          style={{
            width: 14,
            height: 14,
            border: '2px solid currentColor',
            borderRightColor: 'transparent',
            borderRadius: '50%',
            animation: 'graspd-spin 0.7s linear infinite',
            display: 'inline-block',
          }}
        />
      )}
      <span>{children}</span>
    </button>
  );
}
